export const RELICS = {
  "sprint-temporel": {
    id: "sprint-temporel",
    name: "Sprint Temporel",
    description: "Luna peut traverser deux époques d'un seul geste.",
    icon: "⚡",
  },
  "magnetoscope": {
    id: "magnetoscope",
    name: "Magnétoscope",
    description: "Attire les objets à distance à travers les âges.",
    icon: "🧲",
  },
  "aimant-quantique": {
    id: "aimant-quantique",
    name: "Aimant Quantique",
    description: "Verrouille deux causalités en une seule chaîne.",
    icon: "◈",
  },
  "horloge-de-luna": {
    id: "horloge-de-luna",
    name: "Horloge de Luna",
    description: "L'artefact ultime : voir toutes les causalités à la fois.",
    icon: "🕰️",
  },
};
